import { Component } from '@angular/core';

@Component({
    selector: 'app-toolbar-header-section',
    templateUrl: './toolbar-header-section.component.html',
    styleUrls: ['./toolbar-header-section.component.scss'],
    standalone: false
})
export class ToolbarHeaderSectionComponent {}
